import { createFileRoute, notFound, Outlet } from '@tanstack/react-router';
import { isAxiosError } from 'axios';
import { artifactQuery } from '@/features/artifacts/queries';
import { artifactSearchSchema } from '@/features/artifacts/constants';
import { ArtifactNotFound } from '@/features/artifacts/components/artifact-not-found';
import { Main, MainPending } from '@/ui/components/main';

export const Route = createFileRoute('/_authed/project/$projectId/artifacts/$artifactId')({
  component: RouteComponent,
  loader: ({ context, params }) =>
    context.queryClient
      .query({
        ...artifactQuery(params.artifactId),
        staleTime: 'static',
      })
      .catch((error) => {
        if (isAxiosError(error) && error.response?.status === 404) throw notFound();
        throw error;
      }),
  pendingComponent: MainPending,
  notFoundComponent: () => (
    <Main>
      <ArtifactNotFound />
    </Main>
  ),
  validateSearch: artifactSearchSchema,
});

function RouteComponent() {
  return (
    <Main className="flex-row">
      <div className="relative grow flex flex-col min-w-0 min-h-0">
        <Outlet />
      </div>
    </Main>
  );
}
